<template>
  <div>
    <div style="height: 250px;"/>
    <v-container>
      <v-layout justify-center>
        <h1 class="fade-in delay1" style="font-size: 50px;">個人間送金</h1>
      </v-layout>

      <v-layout justify-center>
        <v-card
          class="fade-in delay1"
          color="transparent"
          elevation="0"
          width="800"
        >
          <v-card-text style="font-size: 15px;">
            このページでは、利用者同士で仮想通貨を送金する機能をご紹介します。<br/>
            この機能を活用することで、コミュニティの利用者同士で、自由に仮想通貨のやり取りを行うことができます。
            また、やり取りには管理者は関与しないため、個人的なやり取りにも使用可能です。
            例えば、誕生日祝いや、同僚への労いなどにも使用可能です。
            以下のセクションでは、2つ送金機能「QRコード送金」「シェアリンク送金」と「送金履歴の閲覧」について説明します。
          </v-card-text>
        </v-card>
      </v-layout>

      <div style="height: 300px;"/>

      <div id="QR">
        <v-layout justify-center>
          <h1>QRコード送金</h1>
        </v-layout>

        <v-row justify="center" no-gutters class="mr-10">
          <v-col align-self="center" cols="12" sm="12" md="12" lg="6" xl="6">
            <pics-slider :pics="getPics(pics.sends)"/>

            <slider-dialog :pics="getPics(pics.sends)"/>
          </v-col>

          <v-col align-self="center">
            <v-card
              color="transparent"
              elevation="0"
            >
              <v-card-text style="font-size: 15px;">
                利用者がQRを使用して、別の利用者に仮想通貨を送金する機能です。
                QRコードを使用することで、自身のアカウント情報が送信され、相手はその情報を基に送金を行います。<br/><br/>

                受け取り手となる利用者は、スマホアプリにログインし、画面下のナビゲーションから「Send」を選択し、個人間送金ページを開きます。
                ページを開くと初めにQR読み取り画面が開くため、画面下部にある「My QRcode」をタップし、自身のQRコードを表示します。<br/><br/>

                一方送り手となる利用者は、同様にスマホアプリの個人間送金ページを開き、初めに表示されるQR読み取り画面で、受け取りてのQRコードを読み込みます。
                これにより、送り手側に、受け取り手のアカウント情報、特にウォレットアドレスなどの情報が送られるため、これを基に送金が行われます。
                送り手は、読み込みと同時に表示される送金フォームを入力します。
                入力項目は「送金する仮想通貨の金額」であり、これを入力できたら、画面下部にあるスワイプボタンから送金リクエストを行います。
                サーバで送金処理が完了すると、送りのスワイプボタンに「Success」の表示が出るため、これを確認して処理完了を把握します。<br/><br/>

                受け取り手は、自身のアプリの購入ページを開き、画面を下にスワイプします。
                これによりサーバから情報を取得し、自身の仮想通貨の残高に最新の情報を反映させます。
                受け取り手は送金分だけ残高が増加していることを確認して、送金処理の完了を把握します。
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div style="height: 300px;"/>

      <div id="link">
        <v-layout justify-center>
          <h1>シェアリンク送金</h1>
        </v-layout>

        <v-row justify="center" no-gutters class="mr-10">
          <v-col align-self="center" cols="12" sm="12" md="12" lg="6" xl="6">
            <pics-slider :pics="getPics(pics.links)"/>

            <slider-dialog :pics="getPics(pics.links)"/>
          </v-col>

          <v-col align-self="center">
            <v-card
              color="transparent"
              elevation="0"
            >
              <v-card-text style="font-size: 15px;">
                シェアリンクを使用して、別の利用者に仮想通貨を送金する機能です。
                シェリンクを使用することで、自身のアカウント情報が送信され、相手はその情報を基に送金を行います。
                また、シェアリンクはSNS等を使用したテキストベースのメッセージであるため、遠隔の利用者とのやり取りにも使用することができます。<br/><br/>

                受け取り手となる利用者は、QRコードの時と同様にスマホアプリの個人間送金ページを開き、「My QRcode」をタップして自身のQRコードを表示します。
                表示時、同じ画面のQRコードの下にある「Share」ボタンをクリックします。
                クリックをすると、自身のアカウント情報を基にしたシェアリンクが生成されるので、これを任意のSNSアプリで送り手の利用者に共有します。<br/><br/>

                送り手側の利用者はSNSで受け取ったシェアリンクをタップする、もしくはブラウザに入力することで、シェアリンクを開きます。
                リンクを開くと、ブラウザからリダイレクトされて、本スマホアプリが起動し、送金フォームが開きます。
                送金フォームではQRコード送金と同様に、送金する仮想通貨の金額を入力し、画面下部にあるスワイプボタンから送金リクエストを送ります。
                送金処理完了の確認方法も、QRコード送金と同様で、スワイプボタンの「Success」表示から確認できます。
                受け取り手も自身のスマホアプリで、残高情報を最新に反映させ、送金処理の完了を確認します。
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div style="height: 300px;"/>

      <div id="history">
        <v-layout justify-center>
          <h1>送金履歴確認</h1>
        </v-layout>

        <v-row justify="center" no-gutters class="mr-10">
          <v-col align-self="center" cols="12" sm="12" md="12" lg="6" xl="6">
            <pics-slider :pics="getPics(pics.histories)"/>

            <slider-dialog :pics="getPics(pics.histories)"/>
          </v-col>

          <v-col align-self="center">
            <v-card
              color="transparent"
              elevation="0"
            >
              <v-card-text style="font-size: 15px;">
                利用者が、自身の行った個人間送金の履歴を閲覧できる機能です。<br/>
                これによって、利用者は誰から仮想通貨を受け取り、誰に送ったかが後から確認できます。
                アプリ上では、購入履歴と同じページで表示されるため、操作方法は購入履歴閲覧機能と同じです。<br/><br/>

                履歴確認を行うには、スマホアプリにログイン後、画面下のナビゲーションより「History」を選択し履歴閲覧ページを開きます。
                履歴閲覧ページでは、月毎に履歴がまとめられており、主に2つの項目が閲覧できます。
                1つ目は、ひと月分の「合計送金額」と「合計受取額」です。
                2つ目は、「送金やり取り1件ごとの詳細な履歴」です。送金・受取履歴のカードをタップすると、「送り先/受取元」や「送金/受取金額」などのより詳細な履歴を確認することができます。<br/><br/>

                履歴閲覧ページは月毎に履歴が表示されるため、他の月を確認したい場合は横にスワイプし、ひと月ごとに移動して確認を行ってください。
                以上の操作で、利用者は現在までの送金履歴と受取履歴を確認することができるようになっています。
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div style="height: 100px;"/>

    </v-container>
  </div>
</template>

<script>
import scrollToMixin from '../../../mixin/scrollToMixin'
import PicsSlider from '../components/PicsSlider'
import SliderDialog from '../components/SliderDialog.vue';

export default {
  mixins: [scrollToMixin],
  components: {
    PicsSlider,
    SliderDialog,
  },
  data: () => ({
    pics: {
      sends: ["send_1.png", "send_2.png", "send_3.png", "send_4.png", "send_5.png"],
      links: ["link_1.png", "link_2.png", "send_3.png"],
      histories: ["send_history_1.png", "send_history_2.png", "send_history_3.png"]
    }
  }),
  methods: {
    /**@param {Array<String>} pics */
    getPics: function(pics){
      const img = [];
      pics.map((value) => {
        img.push(require("../../../images/p2p/" + value));
      })
      return img;
    }
  }
}
</script>